import React, { useEffect, useState } from "react";
import { FaArrowAltCircleDown, FaArrowAltCircleUp } from "react-icons/fa";
import "./SecondSlider.css";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";

function SecondSlider({ isData, setIsdata }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const sitedata = useSelector((store) => store.global.loginData);

  const [homeBanners, setHomeBanners] = useState([]);

  useEffect(() => {
    brandingData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval);
  }, [activeIndex]);

  const brandingData = async () => {
    const siteTheme = sitedata?.options?.theme;
    const response = await SendPostRequest("branding/banners", {
      theme: siteTheme,
    });
    setHomeBanners(response?.data);
  };

  const nextSlide = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === homeBanners?.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? homeBanners?.length - 1 : prevIndex - 1
    );
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="slider-container">
      <div className="slideshow">
        {homeBanners?.map((slide, index) => (
          <div key={index}>
            <div
              className={`slide left ${index === activeIndex ||
                index === activeIndex - 1 ||
                (index === homeBanners?.length - 1 && activeIndex === 0)
                ? "active"
                : ""
                } ${index === activeIndex - 1 ||
                  (index === homeBanners?.length - 1 && activeIndex === 0)
                  ? "previous"
                  : ""
                } ${index === activeIndex + 1 ||
                  (index === 0 && activeIndex === homeBanners?.length - 1)
                  ? "next"
                  : ""
                }`}
            >
              <div className="item">
                {slide?.banner_category === "custom-text" && (
                  <div className="shadow"></div>)}
                <img src={`${slide?.banner_image}`} alt={`Slide ${index}`} />
              </div>
            </div>
            <div
              className={`slide right ${index === activeIndex ||
                index === activeIndex - 1 ||
                (index === homeBanners?.length - 1 && activeIndex === 0)
                ? "active"
                : ""
                } ${index === activeIndex - 1 ||
                  (index === homeBanners?.length - 1 && activeIndex === 0)
                  ? "previous"
                  : ""
                } ${index === activeIndex + 1 ||
                  (index === 0 && activeIndex === homeBanners?.length - 1)
                  ? "next"
                  : ""
                }`}
            >
              <div className="item">
                {slide?.banner_category === "custom-text" && (
                  <div className="shadow"></div>
                )}
                <img src={`${slide?.banner_image}`} alt={`Slide ${index}`} />
              </div>
            </div>
          </div>
        ))}
      </div>
      {homeBanners?.map((slide, index) => (
        slide?.banner_category === "custom-text" && (
          <div className="slideshow-text" key={index}>
            <div className="container">
              <div
                // className={`item ${slide?.banner_alignment === "left" ? "align-left" : "align-center"
                //   }`}

                className={`item `}
              >
                <div
                  className={`heading banner-title-font ${index === activeIndex ? "active" : ""
                    } ${index === activeIndex - 1 ||
                      (index === homeBanners?.length - 1 && activeIndex === 0)
                      ? "previous"
                      : ""
                    } ${index === activeIndex + 1 ||
                      (index === 0 && activeIndex === homeBanners?.length - 1)
                      ? "next"
                      : ""
                    }`}
                >
                  {slide?.banner_title}
                </div>
                <div
                  className={`description ${index === activeIndex ? "active" : ""}`}
                >
                  <p>{slide?.banner_description}</p>
                </div>
              </div>
            </div>
          </div>
        )
      ))}


      <div className="dots">
        {homeBanners?.map((slide, index) => (
          <div
            className={`dot-line ${index === activeIndex ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
            key={index}
          ></div>
        ))}
      </div>
      <div className="up-btn" onClick={prevSlide}>
        <FaArrowAltCircleUp />
      </div>
      <div className="down-btn" onClick={nextSlide}>
        <FaArrowAltCircleDown />
      </div>
    </div>
  );
}
export default SecondSlider;
